import { render, staticRenderFns } from "./BatchesView.vue?vue&type=template&id=2e1701be"
import script from "./BatchesView.vue?vue&type=script&lang=js"
export * from "./BatchesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports